import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';

export const TipContainer = styled(Stack)`
  align-items: flex-start;
`;

export const IconContainer = styled.div`
  background-color: ${tokens.color.bg_active};
  border-radius: ${tokens.radius.max};
  min-width: ${tokens.spacer.x6};
  min-height: ${tokens.spacer.x6};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const IllustrationContainer = styled(Stack)`
  & img {
    width: 100%;
  }
`;
